/**
 * @deprecated - Please migrate to the new format. Should be deleted in https://ratehub.atlassian.net/browse/FIT-3936
 * 
 * @param {{ name: string, province: { code: string } } | null} city - old format
 * @returns {{ city: string, province: string } | null} - new format
 */
function getLocationFromCity(city) {
    if (!city) {
        return null;
    }

    return {
        city: city.name,
        province: city.province.code,
    };
}

export default getLocationFromCity;